import { Notification }  from 'old/types'
import { getUserId, useQueryHandler }  from 'old/utils'

//useNotification:
export const useNotification = () => useQueryHandler<Notification>({
    query: `
        query getNotification {
            getNotification {
                id
                type
                message
                description
            }
        }
    `,
    cacheKey: ['notification', getUserId()],
    onSuccess: json => json.data.getNotification
})
